/* eslint-disable @typescript-eslint/no-unused-vars */
/* for mobx decorators? */
import { Button } from '@progress/kendo-react-buttons';
import { inject, observer } from 'mobx-react';
import React from 'react';

import ChatStore from '../../../../stores/ChatStore';
import SuggestedActionsStyle from './SuggestedActionsStyles';

interface ISuggestedActionsProp {
  messageId: string;
  actions: string[];
  onActionClick: (message: string, messageId: string, removeAttachmment?: boolean) => void;
}

export interface IInjectedProps extends ISuggestedActionsProp {
  chatStore: ChatStore;
}

@inject('chatStore')
@observer
class SuggestedActions extends React.Component<ISuggestedActionsProp> {
  protected get injected(): IInjectedProps {
    return this.props as IInjectedProps;
  }

  public render() {
    const { actions, onActionClick, messageId } = this.props;

    const {
      chatStore: { loading },
    } = this.injected;

    if (loading) {
      return null;
    }

    return (
      <SuggestedActionsStyle>
        {actions &&
          actions.map((action: string, index: number) => (
            <Button
              onClick={() => {
                onActionClick(action, messageId, true);
              }}
              key={index}
              primary={true}
              look='outline'
            >
              {action}
            </Button>
          ))}
      </SuggestedActionsStyle>
    );
  }
}

export default SuggestedActions;
